import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'marketInfo',
    standalone: false
})
export class MarketInfoPipe implements PipeTransform {
    transform(value: string): string {
        const [_, ...info] = value?.split(' ') || [];

        return info.join(' ');
    }
}
